import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { GuidePage } from './GuidePage'

export const routes: RouteObject[] = [{ path: '/guide', element: <GuidePage /> }]

// Последним в меню; на телефоне — в «Ещё». Сюда же ведёт карточка «Начни отсюда» на «Сегодня».
export const nav: NavItem[] = [{ path: '/guide', label: 'Гайд', icon: 'info', mobile: 'more', order: 95 }]
